<template>
    <c-dialog ref="dialog" title="背贴码跟踪" width="1200" height="1000" enable-flex mask-close :button="false">
		<div class="scan-input flex-center-cross">
			<c-input ref="codeInput" v-model="scanCode" class="flex-grow" placeholder="请扫描或输入背贴码" style="width: auto; height: 50px; padding: 0 5px; border-radius: 6px 0 0 6px;" @keyup.enter.native="detail(scanCode)">
				<template #appendIcon><i class="tf-scan" style="font-size: 20px; color: #bbb;"></i></template>
			</c-input>
			<c-button color="main" style="width: 60px; height: 50px; padding: 0; border-radius: 0 6px 6px 0; font-size: 24px;" @click="detail(scanCode)"><i class="tf-search"></i></c-button>
		</div>
        <c-empty v-if="emptyState" message="请扫描或输入背贴码"></c-empty>
        <template v-else>
            <c-detail class="m-detail-table" column="3" style="padding-top: 0;">
                <c-detail-item label="商品信息">
                    <c-state tag async dict="LEVEL_TYPE" :value="detailData.level_type"></c-state>
                    {{productName}}

                </c-detail-item>
                <c-detail-item label="背贴码">
                    {{detailData.produce_unique_code}}
                </c-detail-item>
                <c-detail-item label="供应商">
                    {{detailData.supplier_name||'-'}}
                </c-detail-item>
                <c-detail-item label="采购价">
                    ￥{{detailData.purchase_price||'-'}}
                </c-detail-item>
                <c-detail-item label="IMEI码">
                    {{detailData.produce_imei}}
                </c-detail-item>
                <c-detail-item label="采购人">
                    {{detailData.purchase_user_realname||'-'}}
                </c-detail-item>
                <c-detail-item label="维修价">
                    ￥{{detailData.repair_cost||'-'}}
                </c-detail-item>
                <c-detail-item label="在库时长">
                    {{stockDurationText}}
                </c-detail-item>
                <c-detail-item label="当前部门">
                    {{detailData.current_duty_dept_name||'-'}}
                </c-detail-item>
                <c-detail-item label="售价">
                    ￥{{detailData.retail_price||'-'}}
                </c-detail-item>
                <c-detail-item label="入库时间">
                    {{stockInTime||'-'}}
                </c-detail-item>
                <template v-for="(item, i) in customFields">
                    <c-detail-item v-if="item.attribute_id!=detailData.color_id && item.attribute_id!=detailData.memory_id" :key="i" :label="item.attribute_name">
                        <span class="field-value">{{ item.attribute_value }}</span>
                    </c-detail-item>
                </template>
            </c-detail>

            <template v-if="logList && timeList">
                <c-tab-list :tabs="tabs" @change="data => currentTab = data.value"></c-tab-list>

                <!-- 跟踪记录：左侧时间轴（全局倒序后按操作类型大类切分连续小分组）+ 右侧备注/维修卡片 -->
                <div v-if="currentTab == 1" class="track flex">
                    <div class="timeline flex-grow">
                        <c-empty v-if="!timelineNodes.length" height="400"></c-empty>
                        <div v-for="(node, i) in timelineNodes" :key="i" class="node" :class="{'z-crt': i == 0}">
                            <span class="dot"></span>
                            <div class="node-head flex-center-cross">
                                <span class="node-title">{{node.title}}</span>
                                <span class="node-tag">{{node.tag}}</span>
                                <span class="node-date">{{node.date}}</span>
                            </div>
                            <div class="node-sub">
                                <span>{{node.user_name||'-'}}（{{node.dept_name||'-'}}）</span>
                                <span v-if="node.stage">{{node.stage}}</span>
                            </div>
                            <ul v-if="node.logs.length" class="node-log">
                                <li v-for="(log, j) in node.logs" :key="j">
                                    <span>{{log.create_date}}</span>
                                    <span class="log-user">{{log.operator_user_name}}</span>
                                    <span>{{log.action_desc}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="side">
                        <!-- 备注信息：聚合各来源单据创建时填写的备注（线下采购/质检维修销售调拨/分润调拨/线下销售） -->
                        <div class="side-card">
                            <div class="side-head"><i class="tf tf-edit"></i>备注信息</div>
                            <div class="side-body">
                                <p v-if="!remarkList.length" class="side-empty">暂无备注信息</p>
                                <ul v-else class="remark-list">
                                    <li v-for="(item, i) in remarkList" :key="i">
                                        <div class="r-head flex-center-cross">
                                            <span class="dot-mini"></span>
                                            <span class="r-user">{{item.create_user_realname||'-'}}</span>
                                            <span class="node-tag">{{item.source_name}}</span>
                                            <span class="r-date">{{item.create_date}}</span>
                                        </div>
                                        <p class="r-items">{{item.remark}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- 维修记录：维修/送修逐条展示，明细展开到分项金额 -->
                        <div class="side-card">
                            <div class="side-head"><i class="tf tf-repair"></i>维修记录</div>
                            <div class="side-body">
                                <c-empty v-if="!sortedRepairCards.length" height="160"></c-empty>
                                <ul v-else class="repair-list">
                                    <li v-for="(card, i) in sortedRepairCards" :key="i">
                                        <div class="r-head flex-center-cross">
                                            <span class="dot-mini"></span>
                                            <span class="r-user">{{card.user_name||'-'}}</span>
                                            <span v-if="card.kind == 2" class="node-tag">{{card.completed ? '送修' : '送修中'}}</span>
                                            <span class="r-date">{{card.date}}</span>
                                        </div>
                                        <p class="r-items" v-if="card.completed && card.update_name">完成：<span class="r-user">{{card.update_name}}</span></p>
                                        <p class="r-items">{{itemText(card)}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 停留时长：按部门筛选 + 本页合计 -->
                <div v-else class="time">
                    <ul class="tab flex">
                        <li v-for="(item,i) in timeTabList" :key="i" :class="{'z-crt': currentTimeTab == item}" @click="currentTimeTab = item">{{item || '全部'}}</li>
                    </ul>
                    <c-empty v-if="!compTimeList.length" height="400"></c-empty>
                    <table v-else class="time-table">
                        <thead>
                            <tr>
                                <th>姓名</th>
                                <th>所属部门</th>
                                <th>停留时长</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in compTimeList" :key="i">
                                <td>{{item.operator_user_name}}</td>
                                <td>{{item.operator_dept_name}}</td>
                                <td :class="{'z-warn': isCurrentStay(item)}">{{stayText(item)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>本页合计：</td>
                                <td></td>
                                <td>{{totalStayText}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </template>
        </template>
    </c-dialog>
</template>

<script>
export default {
    name: 'produceUniqueCodeDetail',

    props: {
        produce_unique_code: [String, Number]
    },

    data() {
        return {
            emptyState: !this.produce_unique_code,
			scanCode: '',
            detailData: {},
            customFields:undefined,

            tabs: [{
                name: '跟踪记录',
                value: 1
            }, {
                name: '停留时长',
                value: 2
            }],
            currentTab: 1,

            logList: null,

            timeTabList: [],
            currentTimeTab: '',
            timeList: null,

            /**维修/送修记录卡片（kind：1维修 2送修），明细异步回填 */
            repairCards: [],
            /**聚合备注列表（线下采购/质检维修销售调拨/分润调拨/线下销售 单据创建时填写） */
            remarkList: [],
            /**维修项字典 value→name 映射 */
            repairItemMap: {}
        }
    },

    computed: {
        productName() {
            return [this.detailData.brand_name, this.detailData.spu_model_name, this.detailData.color_name, this.detailData.memory_name].filter(item => item).join(' ');
        },

        /**入库时间取最近一次入库，缺失时回退首次入库 */
        stockInTime() {
            return this.detailData.latest_stock_in_time || this.detailData.first_stock_in_time || '';
        },

        /**出库时间：已出库（main_state=4）按子状态取出库动作时间，其余主状态无出库时间返回空 */
        stockOutTime() {
            let data = this.detailData;
            if (data.main_state != 4) return '';
            //42销售出库取销售时间，43/44分润调拨（含退货）出库取分润调拨时间
            if (data.state == 42) return data.sale_time || '';
            if (data.state == 43 || data.state == 44) return data.profit_transfer_time || '';
            //41采购退库、45采购待退回、46采购退回 均以出库时间为准
            return data.stock_out_time || '';
        },

        /**在库时长：在库（main_state=3）累计到当前时间，已出库（main_state=4）计算入库到出库的历时；起止时间缺失或未入库显示- */
        stockDurationText() {
            let startTime = new Date(this.stockInTime).getTime();
            let endTime = this.detailData.main_state == 3 ? Date.now() : new Date(this.stockOutTime).getTime();
            if (!this.stockInTime || isNaN(startTime) || isNaN(endTime)) return '-';
            let diff = endTime - startTime;
            if (diff < 0) return '-';
            let days = Math.floor(diff / 86400000);
            return days >= 1 ? days + '天' : Math.max(1, Math.round(diff / 3600000)) + '小时';
        },

        /**当前部门：最新一条操作日志的作业部门 */
        currentDeptName() {
            return this.lastOperateLog ? this.lastOperateLog.operator_dept_name : '';
        },

        /**最新一条操作日志（备注类日志不参与当前阶段判定） */
        lastOperateLog() {
            let list = (this.logList || []).filter(item => item.log_type == 1);
            return list.length ? list.slice().sort(this.compareLogAsc)[list.length - 1] : null;
        },

        /**
         * 时间轴节点：操作日志先按时间升序排好，再把相邻同大类（见 timelineCategory）的日志切成一个节点，
         * 节点整体倒序展示（最新节点置顶、当前节点高亮），节点内日志保持时间升序。
         * 同一大类被其它大类隔开时会拆成多个节点，例如「销售调拨 → 入库 → 销售」即三段。
         */
        timelineNodes() {
            if (!this.logList) return [];
            let logs = this.logList.filter(item => item.log_type == 1).slice().sort(this.compareLogAsc);
            let groups = [];
            let cur = null;
            logs.forEach(item => {
                let cat = this.timelineCategory(item.action_type);
                if (!cur || cur.key != cat.key) {
                    cur = {key: cat.key, logs: []};
                    groups.push(cur);
                }
                cur.logs.push(item);
            });
            groups.reverse();
            groups.forEach(node => {
                //节点标题/阶段取组内最新一条，同一 key 下细分动作不同（如确认驳回、撤销驳回）时展示最后发生的那个
                let latest = node.logs[node.logs.length - 1];
                let cat = this.timelineCategory(latest.action_type);
                node.title = cat.title;
                node.tag = cat.tag;
                node.stage = cat.stage;
                node.date = latest.create_date;
                node.user_name = latest.operator_user_name;
                node.dept_name = latest.operator_dept_name;
            });
            return groups;
        },

        /**维修/送修卡片按时间倒序展示，同一秒或时间缺失时按id倒序兜底 */
        sortedRepairCards() {
            return this.repairCards.slice().sort((a, b) => (b.date || '').localeCompare(a.date || '') || (b.id || 0) - (a.id || 0));
        },

        compTimeList() {
            return this.timeList ? this.timeList.filter(item => !this.currentTimeTab || this.currentTimeTab == item.operator_dept_name) : null;
        },

        /**本页合计：筛选后停留小时数求和，再统一换算单位，避免已取整天数造成精度损失 */
        totalStayText() {
            let list = this.compTimeList || [];
            if (!list.length) return '-';
            let hours = list.reduce((acc, cur) => acc + (Number(cur.total_stay_hours) || 0), 0);
            return hours >= 24 ? Math.round(hours / 24 * 10) / 10 + '天' : Math.round(hours * 10) / 10 + '小时';
        }
    },

    methods: {
        /**
         * 日志排序（升序）：create_date 为主键，时间相同或缺失时用自增 id 兜底。
         * 不能只按 id 排：迁移/修复数据、跨服务 MQ 异步写入都会让 id 顺序与业务时间不一致，
         * 历史数据曾出现同一节点内跨天错位，只有时间才是跟踪记录的真实先后
         */
        compareLogAsc(a, b) {
            let ta = this.logStamp(a);
            let tb = this.logStamp(b);
            if (ta != tb) return ta - tb;
            //时间解析不出来时退化为字符串字典序（同格式下等价于时间序），依旧比 id 可靠
            let sa = (a && a.create_date) || '';
            let sb = (b && b.create_date) || '';
            if (ta == 0 && String(sa) != String(sb)) return String(sa) < String(sb) ? -1 : 1;
            return ((a && a.id) || 0) - ((b && b.id) || 0);
        },

        /**
         * 日志时间转毫秒数：兼容 Date、毫秒数、'yyyy-MM-dd HH:mm[:ss]' 与 ISO 'yyyy-MM-ddTHH:mm:ss[.SSSZ]'。
         * 统一改写成 / 分隔的本地时间串再解析，避免 Safari 不认带 - 的日期串；解析不了返回 0
         */
        logStamp(log) {
            let v = log ? log.create_date : null;
            if (!v) return 0;
            if (typeof v == 'number') return v;
            if (v instanceof Date) return v.getTime();
            let s = String(v).trim().replace('T', ' ').replace(/\.\d+/, '').replace(/Z$/, '');
            let t = new Date(s.replace(/-/g, '/')).getTime();
            if (isNaN(t)) t = Date.parse(String(v));
            return isNaN(t) ? 0 : t;
        },

        /**
         * 操作类型大类映射（与 ActionTypeEnum 分段一致，一个 action_type 只落一个大类）：
         * 0~2 采集/绑定/取消绑定与90背贴码打印归条码采集（打印属采集环节的系统动作）；
         * 3初检、9采购确认收货、4入库各自单独成节点；-1删除、5申请退库/6退库、10取消退库归出入库；
         * 7~8调拨驳回（确认驳回/撤销驳回）单独成节点；
         * 11~18质检（含18串号变更） / 21~26维修 / 31~40销售 / 41~48分润调拨各自成节点；
         * 50~52线下订单+53~58售后+67~69同售+93~97线上订单通知属于订单交易，与销售动作归同一大类；
         * 60~66渠道同步+70~74渠道恢复/自动上下架/重置发布/渠道通知归渠道同步；80~82暗拍单独成节点；
         * 区间外未知类型归入其他，避免落错大类（ActionTypeEnum 新增类型必须显式登记此处区间）
         */
        timelineCategory(type) {
            if ((type >= 0 && type <= 2) || type == 90) return {key: 'collect', title: '条码采集', tag: '采集', stage: '采集 → 绑定'};
            if (type == 3) return {key: 'purchase_check', title: '初检', tag: '初检', stage: '采购 → 初检'};
            if (type == 9) return {key: 'purchase_receipt', title: '采购收货', tag: '收货', stage: '采购 → 收货'};
            if (type == 4) return {key: 'stock_in', title: '初次入库', tag: '入库', stage: '采购 → 入库'};
            if (type == 7) return {key: 'handover_reject', title: '调拨', tag: '调拨', stage: '确认驳回'};
            if (type == 8) return {key: 'handover_reject', title: '调拨', tag: '调拨', stage: '撤销驳回'};
            if (type == -1 || (type >= 5 && type <= 6) || type == 10) return {key: 'stock', title: '出入库操作', tag: '出入库', stage: '入库 → 出库'};
            if (type >= 11 && type <= 18) return {key: 'quality', title: '质检', tag: '质检', stage: '接驳 → 质检'};
            if (type >= 21 && type <= 26) return {key: 'repair', title: '维修', tag: '维修', stage: '接驳 → 维修'};
            if ((type >= 31 && type <= 40) || (type >= 50 && type <= 58) || (type >= 67 && type <= 69) || (type >= 93 && type <= 97)) return {key: 'sale', title: '销售', tag: '销售', stage: '接驳 → 销售'};
            if (type >= 41 && type <= 48) return {key: 'profit', title: '分润调拨', tag: '分润', stage: '在库 → 调拨'};
            if ((type >= 60 && type <= 66) || (type >= 70 && type <= 74)) return {key: 'channel', title: '渠道同步', tag: '渠道', stage: '在售 → 渠道'};
            if (type >= 80 && type <= 82) return {key: 'dark', title: '暗拍', tag: '暗拍', stage: '暗拍场次'};
            return {key: 'other', title: '其他操作', tag: '其他', stage: ''};
        },

        /**维修项字典名 */
        repairItemName(id) {
            return this.repairItemMap[id] || id;
        },

        /**维修卡片明细文案：分项名+金额竖线分隔；明细未返回时回退列表接口的聚合文本 */
        itemText(card) {
            if (card.items.length) {
                return card.items.map(item => this.repairItemName(item.repair_item) + ' ￥' + item.repair_amount).join(' | ');
            }
            return card.fallback || '-';
        },

        /**停留时长文案 */
        stayText(item) {
            return item.total_stay_days >= 1 ? item.total_stay_days + '天' : item.total_stay_hours + '小时';
        },

        /**当前停留阶段（最新操作日志的作业人+部门）标红提示仍在累计 */
        isCurrentStay(item) {
            let last = this.lastOperateLog;
            return !!last && !!item.operator_user_name
                && item.operator_user_name == last.operator_user_name
                && item.operator_dept_name == last.operator_dept_name;
        },

        /**加载维修项字典（value→name） */
        loadRepairItemDic() {
            if (Object.keys(this.repairItemMap).length) return;
            this.request({
                url: '/system/dic/options',
                data: {dic_type_code: 'REPAIR_ITEM'},
                success: data => {
                    (data || []).forEach(item => {
                        this.$set(this.repairItemMap, item.value, item.name);
                    });
                }
            });
        },

        /**加载聚合备注列表（数据来源：线下采购/质检维修销售调拨/分润调拨/线下销售 单据创建时填写的备注） */
        loadRemarks(productCodeId, produceUniqueCode) {
            this.request({
                url: '/productCode/remark/listByCodeId',
                data: {
                    produce_unique_code_id: productCodeId,
                    produce_unique_code: produceUniqueCode
                },
                success: data => {
                    this.remarkList = data || [];
                }
            });
        },

        /**加载维修/送修记录卡片，明细金额走各自详情接口回填 */
        loadRepairCards(productCodeId) {
            this.repairCards = [];
            this.request({
                url: '/repair/record/listByProduct',
                data: {produce_unique_code_id: productCodeId},
                success: data => {
                    let list = (data && data.obj) ? data.obj : (data || []);
                    list.forEach(record => {
                        let card = {kind: 1, id: record.id, user_name: record.repair_user_name || record.create_user_name, date: record.create_date, items: [],
                            fallback: record.repair_item_name ? record.repair_item_name + ' ￥' + record.repair_amount : ''};
                        this.repairCards.push(card);
                        this.request({
                            url: '/repair/record/detail',
                            data: {id: record.id},
                            success: d => {
                                card.items = (d && d.details) || [];
                            }
                        });
                    });
                }
            });
            this.request({
                url: '/repair/delivery/list',
                data: {produce_unique_code_id: productCodeId, page_size: 100},
                success: data => {
                    let list = (data && data.obj) ? data.obj : (data || []);
                    list.forEach(record => {
                        let completed = record.delivery_state == 2;
                        let card = {
                            kind: 2,
                            id: record.id,
                            user_name: record.sender_user_name || record.create_user_name,
                            date: completed ? (record.complete_date || record.create_date) : record.create_date,
                            completed: completed,
                            items: [],
                            update_name: completed ? (record.update_user_name || '') : '',
                            fallback: record.repair_item_name ? record.repair_item_name + ' ￥' + record.repair_amount : ''};
                        this.repairCards.push(card);
                        this.request({
                            url: '/repair/delivery/detail',
                            data: {id: record.id},
                            success: d => {
                                card.items = (d && d.details) || [];
                            }
                        });
                    });
                }
            });
        },

        /**
         * 加载详情
         */
        detail(code){
            if (!code.trim()) {
                this.$message({
                    message: '请扫描或输入背贴码'
                });
                return;
            }
            this.request({
                url: '/productCode/queryByCode',
                data: {
                    produce_unique_code: code.trim()
                },
                loading: true,
                success: data => {
                    this.emptyState = false;
                    this.detailData = data;
                    if (this.detailData.custom_fields_value_json && this.detailData.custom_fields_value_json.attribute){
                        this.customFields = this.detailData.custom_fields_value_json.attribute;
                    }else if (this.detailData.initial_inspection_json && this.detailData.initial_inspection_json.attribute){
                        this.customFields = this.detailData.initial_inspection_json.attribute
                    }

                    this.currentTab = 1;
                    this.logList = null;
                    this.currentTimeTab = '';
                    this.timeTabList = [];
                    this.timeList = null;
                    this.repairCards = [];
                    this.remarkList = [];
                    this.request({
                        url: '/productCode/log/listByCodeId',
                        data: {
                            produce_unique_code_id: data.id
                        },
                        success: data => {
                            this.logList = data;
                        }
                    });
                    this.request({
                        url: '/productCode/downtime/listByCodeId',
                        data: {
                            produce_unique_code_id: data.id
                        },
                        success: data => {
                            let list = data.map(item => item.operator_dept_name).filter(item => item).reduce((acc, cur) => {
                                if(!acc.includes(cur)) acc.push(cur);
                                return acc;
                            }, [])
                            this.timeTabList = [''].concat(list);
                            this.timeList = data;
                        }
                    });
                    this.loadRepairItemDic();
                    this.loadRepairCards(data.id);
                    this.loadRemarks(data.id, data.produce_unique_code || this.produce_unique_code);
                },
                complete: () => {
                    this.scanCode = ''
                }
            });
        },
        open(data) {
            this.produce_unique_code && this.detail(this.produce_unique_code);
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
	.scan-input
		padding 24px 150px 28px

    .track {
        gap: 14px;
        padding: 18px 26px 10px;
    }

    .node-tag {
        border-radius: 4px;
        border: 1px solid #B9C8FF;
        padding: 0 6px;
        margin-left: 8px;
        line-height: 18px;
        font-size: 12px;
        color: var(--color-main);
    }

    .timeline {
        min-width: 0;

        .node {
            position: relative;
            padding: 0 0 18px 18px;

            &:before {
                content: '';
                position: absolute;
                left: 4px;
                top: 16px;
                bottom: -2px;
                width: 1px;
                background: #E5E8F0;
            }

            &:last-child:before {
                display: none;
            }

            .dot {
                position: absolute;
                left: 0;
                top: 5px;
                box-sizing: border-box;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                border: 2px solid #C0C6D4;
                background: #fff;
            }

            &.z-crt {
                .dot {
                    border-color: var(--color-main);
                    box-shadow: 0 0 0 2px rgba(61, 94, 255, .15);
                }

                .node-title {
                    color: var(--color-main);
                }
            }
        }

        .node-head {
            gap: 2px;

            .node-title {
                font-size: 14px;
                font-weight: 600;
                color: #333;
            }

            .node-date {
                margin-left: auto;
                font-size: 12px;
                color: #999;
            }
        }

        .node-sub {
            display: flex;
            gap: 24px;
            margin: 10px 0;
            font-size: 13px;
            color: #666;
        }

        .node-log {
            border: 1px solid #eee;
            border-radius: 4px;
            background: #F9F9F9;

            li {
                padding: 10px 12px;
                line-height: 18px;
                font-size: 12px;
                color: #666;
                word-break: break-word;

                & + li {
                    border-top: 1px solid #eee;
                }
            }

            .log-user {
                margin: 0 .5em;
                color: #000;
            }
        }
    }

    .side {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        gap: 14px;
        position: sticky;
        top: 18px;
        width: 300px;
        flex-shrink: 0;

        &-card {
            display: flex;
            flex-direction: column;
            border-radius: 4px;
            border: 1px solid #EBEDF2;
        }

        &-head {
            border-radius: 4px 4px 0 0;
            padding: 12px 12px;
            font-size: 13px;
            font-weight: 600;
            color: #333;
            background: #F9F9F9;

            .tf {
                margin-right: 6px;
                color: #666;
            }
        }

        &-body {
            flex-grow: 1;
            padding: 10px 12px;
        }

        &-empty {
            padding: 40px 0;
            text-align: center;
            font-size: 12px;
            color: #ccc;
        }
    }

    .repair-list, .remark-list {
        li {
            & + li {
                border-top: 1px solid #F0F1F4;
            }

            padding: 12px 0;
        }
        .r-user {
            font-size: 13px;
            font-weight: 600;
            color: var(--color-main);
        }
        .r-head {
            .dot-mini {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                margin-right: 6px;
                background: var(--color-main);
            }

            .node-tag {
                margin-left: 6px;
            }

            .r-date {
                margin-left: auto;
                font-size: 12px;
                color: #999;
            }
        }

        .r-items {
            margin: 6px 0 0 12px;
            font-size: 12px;
            color: #333;
            word-break: break-word;
        }
    }

    .tab {
        gap: 10px;
        padding: 0 26px;
        margin-top: 18px;

        li {
            border-radius: 4px;
            padding: 0 8px;
            line-height: 28px;
            font-size: 14px;
            color: var(--color-main);
            background: #F5F7FF;
            cursor: pointer;

            &:hover, &.z-crt {
                color: #fff;
                background: var(--color-main);
            }
        }
    }

    .time-table {
        border-spacing: 0;
        width: calc(100% - 52px);
        margin: 10px 26px 16px;

        th, td {
            border: 1px solid #EBEDF2;
            padding: 0 12px;
            line-height: 36px;
            font-size: 13px;
            text-align: left;
            color: #333;
        }

        th {
            background: #F9F9F9;
        }

        td.z-warn {
            color: #F5222D;
        }

        tfoot td {
            background: #F2FBEC;
        }
    }
</style>
